export const IFRAME_URL = {
    Local: 'http://localhost:3333',
    Dev: 'https://app.dev.facewallet.xyz',
    StageTestnet: 'https://app.stage-test.facewallet.xyz',
    StageMainnet: 'https://app.stage.facewallet.xyz',
    ProdTestnet: 'https://app.test.facewallet.xyz',
    ProdMainnet: 'https://app.facewallet.xyz',
};
//# sourceMappingURL=iframeUrl.js.map